declare global {
    interface Window {
      env: {
        API_URL: string;
        SIGNALR_URL: string;
        BASE_URL: string;
        VERSION: string;
        COMPANY: string;
        APP_ID: string;
        HASH_SALT: string;
        MODE: string
      }
    }
  }
  
  const env = {
    API_URL: window.env.API_URL,
    SIGNALR_URL: window.env.SIGNALR_URL,
    BASE_URL: window.env.BASE_URL,
    VERSION: window.env.VERSION,
    COMPANY: window.env.COMPANY,
    APP_ID: window.env.APP_ID,
    HASH_SALT: window.env.HASH_SALT,
    MODE: window.env.MODE
  };
  
  export default env;
